module.exports = __webpack_public_path__ + "img/ilustraciones_dudas.d6521ca1.svg";